Module('paginas.facil123-home', function(Page) {
  'use strict';

  Page.fn.initialize = function() {
    Module.run('componentes.navbar-site');
    Module.run('componentes.video-player');
    Module.run('componentes.features-carousel');
  };
});
